import React from 'react';
import { Box, Typography, FormControl, RadioGroup, FormControlLabel, Radio } from '@mui/material';
import { dualCareerQuestions } from '../../data/profileQuestions';

interface DualCareerValues {
  practice: string;
  competition: string;
  competitionPriority: string;
  workStyle: string;
  balanceOrientation: string;
  nonNegotiable: string;
}

interface Props {
  values: DualCareerValues;
  onChange: (values: DualCareerValues) => void;
}

const DualCareerForm: React.FC<Props> = ({ values, onChange }) => {
  const questions = [
    { key: 'practice' as const, ...dualCareerQuestions.practice },
    { key: 'competition' as const, ...dualCareerQuestions.competition },
    { key: 'competitionPriority' as const, ...dualCareerQuestions.competitionPriority },
    { key: 'workStyle' as const, ...dualCareerQuestions.workStyle },
    { key: 'balanceOrientation' as const, ...dualCareerQuestions.balanceOrientation },
    { key: 'nonNegotiable' as const, ...dualCareerQuestions.nonNegotiable },
  ];

  return (
    <Box>
      <Typography variant="h6" sx={{ fontWeight: 600, mb: 1 }}>
        デュアルキャリア条件
      </Typography>
      <Typography variant="body2" sx={{ mb: 3, color: '#666' }}>
        競技と仕事の両立に関する希望条件を教えてください
      </Typography>

      {questions.map(({ key, question, options }) => (
        <Box key={key} sx={{ mb: 4 }}>
          <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 1.5 }}>
            {question}
          </Typography>
          <FormControl>
            <RadioGroup
              value={values[key]}
              onChange={(e) => onChange({ ...values, [key]: e.target.value })}
            >
              {options.map((option) => (
                <FormControlLabel
                  key={option}
                  value={option}
                  control={<Radio />}
                  label={option}
                  sx={{ mb: 0.5 }}
                />
              ))}
            </RadioGroup>
          </FormControl>
        </Box>
      ))}
    </Box>
  );
};

export default DualCareerForm;
